const GavelIcon = () => {
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 34V24.7273H5V21.6364H0V12.3636H5V9.27273H0V0H14V9.27273H9V12.3636H14V15.4545H20V12.3636H34V21.6364H20V18.5455H14V21.6364H9V24.7273H14V34H0ZM4 30.9091H10V27.8182H4V30.9091ZM4 18.5455H10V15.4545H4V18.5455ZM24 18.5455H30V15.4545H24V18.5455ZM4 6.18182H10V3.09091H4V6.18182Z"
        fill="#1868DB"
      />
    </svg>
  );
};

export default GavelIcon;
